import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

import Header from "./components/header/header";
import Footer from "./components/footer/footer";
import ScrollToTop from "./components/scrollToTop";
import WhatsappButton from "./components/whatsappButton";
import useVisitNotifier from "./lib/visitNotifier";

import Hero from "./modules/companyOverview";
import Services from "./modules/services";
import HowItWorks from "./modules/howItWorks";
import Testimonials from "./modules/testimonials";
import Packages from "./modules/packages";
import Faq from "./modules/faq";
import About from "./modules/about";
import Events from "./modules/events";
import Partners from "./modules/partners";
import Careers from "./modules/careers";
import CareerJobDetail from "./modules/careerJobDetail";
import CareersHowWeHire from "./modules/careersHowWeHire";
import CareersLife from "./modules/careersLife";
import CareersBenefits from "./modules/careersBenefits";
import CareersFaq from "./modules/careersFaq";
import Book from "./modules/book";
import Contact from "./modules/contact";
import PrivacyPolicy from "./pages/privacyPolicy";

const CtaBand = () => (
  <section className="bg-brand py-16 lg:py-20">
    <div className="max-w-content mx-auto flex flex-col items-start gap-6 px-6 lg:flex-row lg:items-center lg:justify-between lg:px-10">
      <h2 className="text-2xl font-bold text-paper sm:text-3xl">
        Ready to plan the event?
      </h2>
      <Link
        to="/book"
        className="inline-flex items-center gap-2 rounded-full bg-action px-6 py-3.5 text-base font-medium text-paper hover:bg-action/90 transition-colors"
      >
        Get your free quote
        <FiArrowRight />
      </Link>
    </div>
  </section>
);

const Home = () => (
  <div>
    <Hero />
    <Services />
    <HowItWorks />
    <Testimonials />
    <CtaBand />
  </div>
);

const App = () => {
  useVisitNotifier();

  return (
    <Router>
      <div className="font-sans min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/packages" element={<Packages />} />
            <Route path="/events" element={<Events />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/partners" element={<Partners />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/careers/jobs/:slug" element={<CareerJobDetail />} />
            <Route path="/careers/how-we-hire" element={<CareersHowWeHire />} />
            <Route path="/careers/life-at-nirkana" element={<CareersLife />} />
            <Route path="/careers/benefits" element={<CareersBenefits />} />
            <Route path="/careers/faq" element={<CareersFaq />} />
            <Route path="/book" element={<Book />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <ScrollToTop />
        <WhatsappButton />
        <Footer />
      </div>
    </Router>
  );
};

export default App;
